import { FileText, Tag, BadgePercent, Headset, MousePointerClick } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, SectionHead } from "./Reveal";

const ICONS = [FileText, Tag, BadgePercent, Headset, MousePointerClick];

const Trust = () => {
  const { t } = useLanguage();
  const items = t("trust.items");

  return (
    <section id="trust" data-testid="trust-section" className="border-y border-white/[0.05] bg-coal/60">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-28">
        <SectionHead eyebrow={t("trust.eyebrow")} title={t("trust.title")} />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div
                  data-testid={`trust-item-${i + 1}`}
                  className="group h-full rounded-2xl border border-white/[0.06] bg-[#0c0c10] p-6 transition-all duration-500 hover:-translate-y-1 hover:border-gold/35"
                >
                  <Icon className="h-6 w-6 text-gold" aria-hidden="true" />
                  <h3 className="mt-4 text-sm font-bold uppercase tracking-wider text-white">{item.t}</h3>
                  <p className="mt-2.5 text-xs leading-relaxed text-slate-400">{item.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Trust;
